module.exports = MaterialUI.Paper;